import React, { ChangeEvent, FunctionComponent, memo } from 'react';

import {
  ToggleInput,
  ToggleLoading,
  ToggleSlider,
  ToggleSwitch,
} from './styles';
import { black } from 'utils/style/colors';

type ComponentProps = {
  checked: boolean;
  customStyle?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
  disabled?: boolean;
  loading?: boolean;
  label?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  backgroundColor?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Toggle: FunctionComponent<ComponentProps> = ({
  checked,
  customStyle,
  disabled,
  loading = false,
  onChange,
  label,
  wrapperStyle,
  backgroundColor,
  ...restProps
}) => {
  return (
    <div style={wrapperStyle}>
      {label && (
        <label style={{ marginInlineEnd: '10px', color: black }}>{label}</label>
      )}
      <ToggleSwitch loading={loading} style={customStyle && customStyle}>
        <ToggleInput
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          type="checkbox"
          {...restProps}
        />
        <ToggleSlider backgroundColor={backgroundColor} />
        {loading && <ToggleLoading checked={checked} />}
      </ToggleSwitch>
    </div>
  );
};

export default memo(Toggle);
